import { DataTable } from 'component/CompIndex';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getPaymentScheduleTableData } from 'staticData/LeaseData';

const PaymentSchedulingListing = ({ count }) => {
  const dispatch = useDispatch();
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState('');
  const [searchParams, setSearchParam] = useSearchParams();
  const { data, columns } = getPaymentScheduleTableData();
  return (
    <DataTable
      {...{
        columns,
        data,
        count,
        pageNo,
        setPageNo,
        searchParams,
        setSearchParam,
      }}
    />
  );
};

export default PaymentSchedulingListing;
